import React from "react";

const ICON_PATHS = {
  account: ["M20 21a8 8 0 0 0-16 0", "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"],
  activity: ["M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9", "M10 21h4"],
  alert: ["M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z", "M12 9v4", "M12 17h.01"],
  analysis: ["M4 19V9", "M10 19V5", "M16 19v-7", "M22 19V3"],
  animals: ["M8.5 13.5c-2.5 1.2-3.5 3-2.7 4.8.8 1.7 2.8 1.6 4.3.7 1.2-.7 2.6-.7 3.8 0 1.5.9 3.5 1 4.3-.7.8-1.8-.2-3.6-2.7-4.8-3.1-1.4-6.3-1.4-9.4 0Z", "M7 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", "M17 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", "M3.5 13a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z", "M20.5 13a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"],
  campaigns: ["M5 4v16", "M5 5h12l-2 4 2 4H5"],
  chevronDown: "m6 9 6 6 6-6",
  chevronRight: "m9 18 6-6-6-6",
  arrowLeft: ["M19 12H5", "m11 6-6 6 6 6"],
  chevronsLeft: ["m11 17-5-5 5-5", "m18 17-5-5 5-5"],
  chevronsRight: ["m6 17 5-5-5-5", "m13 17 5-5-5-5"],
  close: "M6 6l12 12M18 6 6 18",
  compass: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z", "m16.24 7.76-2.12 6.36-6.36 2.12 2.12-6.36Z"],
  database: ["M12 8c4.4 0 8-1.3 8-3s-3.6-3-8-3-8 1.3-8 3 3.6 3 8 3Z", "M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5", "M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3"],
  dashboard: ["M4 4h6v6H4z", "M14 4h6v6h-6z", "M4 14h6v6H4z", "M14 14h6v6h-6z"],
  enclosures: ["M4 20V8l8-5 8 5v12", "M8 20v-6h8v6"],
  enrichment: ["M5 19c7 0 12-5 14-14-9 2-14 7-14 14Z", "M5 19c3-5 7-8 12-11"],
  establishment: ["M4 21V7l8-4 8 4v14", "M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01M10 21v-3h4v3"],
  ethograms: ["M5 4h14v16H5z", "M8 8h8M8 12h8M8 16h5"],
  evaluation: ["M9 11l2 2 4-5", "M6 3h12v18H6z"],
  grids: ["M4 4h6v6H4z", "M14 4h6v6h-6z", "M4 14h6v6H4z", "M14 14h6v6h-6z"],
  groups: ["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z", "M22 21v-2a4 4 0 0 0-3-3.87", "M16 3.13a4 4 0 0 1 0 7.75"],
  guides: ["M4 5.5A3.5 3.5 0 0 1 7.5 2H12v18H7.5A3.5 3.5 0 0 0 4 23Z", "M20 5.5A3.5 3.5 0 0 0 16.5 2H12v18h4.5A3.5 3.5 0 0 1 20 23Z"],
  health: ["M12 21s-8-4.5-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 6.5-8 11-8 11Z", "M9 12h6M12 9v6"],
  help: ["M9.1 9a3 3 0 1 1 5.8 1c0 2-3 2-3 4", "M12 18h.01", "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"],
  history: ["M3 12a9 9 0 1 0 3-6.7L3 8", "M3 3v5h5", "M12 7v5l3 2"],
  fullscreen: ["M8 3H3v5", "M16 3h5v5", "M8 21H3v-5", "M16 21h5v-5"],
  gallery: ["M4 5h16v14H4z", "M9 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", "m4 17 5-4 4 3 3-3 4 4"],
  notes: ["M17 3l4 4L8 20l-5 1 1-5Z", "M14 6l4 4"],
  live: ["M3 12h4l2-6 4 12 2-6h6"],
  menu: "M4 7h16M4 12h16M4 17h16",
  key: ["M15 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z", "m11 13-8 8", "M3 17v4h4"],
  shield: ["M12 3 3 7v5c0 5 9 9 9 9s9-4 9-9V7Z", "m8 12 3 3 5-6"],
  mobile: ["M7 2h10v20H7Z", "M11 18h2"],
  logout: ["M10 17l5-5-5-5", "M15 12H3", "M15 3h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-5"],
  monitoring: ["M4 18V6", "M4 18h16", "m7 15 3-4 3 2 4-6"],
  pin: ["M12 16v6", "M7 3h10l-1.2 7.2L19 13H5l3.2-2.8Z"],
  objectives: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z", "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z", "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"],
  questionnaires: ["M9 11l2 2 4-4", "M5 3h14v18H5z"],
  reports: ["M6 2h9l3 3v17H6z", "M14 2v5h5", "M9 12h6M9 16h6"],
  search: "m21 21-4.35-4.35m2.35-5.65a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
  sectors: ["M4 6l5-3 6 3 5-3v15l-5 3-6-3-5 3Z", "M9 3v15M15 6v15"],
  settings: ["M4 7h10M18 7h2M4 17h2M10 17h10M14 4v6M6 14v6"],
  support: ["M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z", "M8 9h8M8 13h5"],
  sync: ["M20 7h-5V2", "M4 17h5v5", "M5.5 9A8 8 0 0 1 19 5l1 2", "M18.5 15A8 8 0 0 1 5 19l-1-2"],
  // Fiole de laboratoire : projets scientifiques.
  research: ["M9.5 2v7.5L4.6 19.7A1.5 1.5 0 0 0 5.9 22h12.2a1.5 1.5 0 0 0 1.3-2.3L14.5 9.5V2", "M8 2h8", "M6.8 16h10.4"],
  tasks: ["M9 11l2 2 4-4", "M5 3h14v18H5z"],
  technical: ["M14.7 6.3a4 4 0 0 0-5-5L7 4l3 3 2.7-2.7a4 4 0 0 0 5 5L10 17l-3 3-3-3 3-3Z"],
  timeline: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z", "M12 6v6l4 2"],
  tours: ["M5 19c3-7 7-2 10-8 1.5-3-1-5-3-3", "M5 19h.01M12 8h.01M19 4h.01"],
  training: ["M2 10l10-5 10 5-10 5Z", "M6 12v5c3 2 9 2 12 0v-5"],
  users: ["M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z", "M19 8v6M16 11h6"],
  weather: ["M17.5 19H7a5 5 0 1 1 1.1-9.9A7 7 0 0 1 21 12.5 3.5 3.5 0 0 1 17.5 19Z"],
};

export default function ShellIcon({ name, size = "medium" }) {
  return (
    <svg
      aria-hidden="true"
      className={`${size === "tiny" ? "akv:h-2.5 akv:w-2.5" : size === "small" ? "akv:h-4 akv:w-4" : "akv:h-5 akv:w-5"} akv:flex-none`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {(Array.isArray(ICON_PATHS[name]) ? ICON_PATHS[name] : [ICON_PATHS[name]])
        .filter(Boolean)
        .map((path) => <path d={path} key={path} />)}
    </svg>
  );
}
